import { Modal, Radio, RadioChangeEvent } from 'antd';
import { useState } from 'react';
import { InputWithSign } from '../../../common/components/input-with-sign';
import { ButtonPrimary } from '@/shared/ui/button';
import styles from './index.module.sass';
import { mixingQueryParamsStore, updateMixAlgo, updateRecipesCount, updateTons } from '../../store/mixing-query-params.store';
import { useStore } from 'effector-react';

export const ProfitDataModal = ({ visible, setVisible, handler }: IProfitDataModal) => {
  // const [radioValue, setRadioValue] = useState(3);
  // const [formData, setFormData] = useState<{
  //   tons: number | null;
  //   recipesCount: number | null;
  // }>({
  //   tons: null,
  //   recipesCount: null,
  // });
  const mixingQueryParams = useStore(mixingQueryParamsStore);


  return (
    <Modal
      title="параметры расчета миксования"
      footer={[]}
      width={380}
      onCancel={() => setVisible(false)}
      open={visible}
    >
      <div className={styles.topBlock}>
        <span className="">подбор рецептов по:</span>
        <Radio.Group
          className={styles.radioBlock}
          value={mixingQueryParams.mix_algo}
          onChange={(e: RadioChangeEvent) => updateMixAlgo(e.target.value)}
        >
          <Radio value={3}>максимальной выгоде за указанную единицу веса</Radio>
          <Radio value={1}>максимальной выгоде за указанный вес микса</Radio>
        </Radio.Group>
        <div>
          <InputWithSign
            value={Number(mixingQueryParams.tons)}
            onChange={(e) =>
              updateTons(+e.target.value.replaceAll(/[^0-9.]/g, ''))
            }
            postfix="т"
            label={mixingQueryParams.mix_algo === 3 ? "максимальная выгода за указанный вес" : "вес микса"}
          />
          <InputWithSign
            value={mixingQueryParams.recipes_count ? Number(mixingQueryParams.recipes_count) : ''}
            postfix=""
            onChange={(e) =>
              updateRecipesCount(+e.target.value.replaceAll(/[^0-9.]/g, ''))
            }
            label="итоговое количество  рецептов"
          />
        </div>
        <div>
          <ButtonPrimary
            disabled={
              Number(mixingQueryParams.tons) < 0 ||
              Number(mixingQueryParams.recipes_count) <= 0 ||
              Number(mixingQueryParams.mix_algo) <= 0
            }
            className={styles.button}
            onClick={() =>
              handler({
                tons: mixingQueryParams.tons,
                recipesCount: mixingQueryParams.recipes_count,
                mixAlgo: mixingQueryParams.mix_algo,
              })
            }
            label={'получить варианты'}
          />
        </div>
      </div>
    </Modal>
  );
};

interface IProfitDataModal {
  visible: boolean;
  setVisible: (val: boolean) => void;
  handler: (args: any) => void;
}
